import { resolveUnitToBaseRate } from './resolveUnitToBaseRate';

/**
 * 可用量（base）÷ rate(unit) 的可輸入整數上限；缺 rate 當 1。
 *
 * @param {unknown} availableBase
 * @param {Array<object>|null|undefined} unitOptions
 * @param {string} [unitId]
 * @returns {number}
 */
export function maxQtyInUnit(availableBase, unitOptions, unitId) {
  const available = Number(availableBase);
  if (!Number.isFinite(available) || available <= 0) {
    return 0;
  }
  const rate = resolveUnitToBaseRate(unitOptions, unitId) ?? 1;
  if (!Number.isFinite(rate) || rate <= 0) {
    return Math.floor(available);
  }
  return Math.floor(available / rate);
}
